import { Fragment, useEffect } from "react";
import svgPaths from "../../assets/new_ui_imports/Technology/svg-squwu7zinr.js";
import imgHeroBg from "../../assets/new_ui_img/technology_banner.jpg";
import imgStep1 from "../../assets/new_ui_img/howit_1.svg";
import imgStep2 from "../../assets/new_ui_img/howit_2.svg";
import imgStep3 from "../../assets/new_ui_img/howit_3.svg";
import imgStep4 from "../../assets/new_ui_img/howit_4.svg";
import imgStep5 from "../../assets/new_ui_img/howit_5.svg";
import imgFleetCard from "../../assets/new_ui_img/howit_image.png";
import imgMaximize from "../../assets/new_ui_img/maximize.png";
import imgShape from "../../assets/new_ui_img/shape.jpg";
import imgUnlock from "../../assets/new_ui_img/unlock.jpg";
import imgStay from "../../assets/new_ui_img/stay.jpg";
import { Header, Footer, ScrollToTop } from "./components/Header";

// ─── Scroll reveal ─────────────────────────────────────────────────────────────
function useReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); }),
      { threshold: 0.07, rootMargin: "0px 0px -40px 0px" }
    );
    document.querySelectorAll(".tech-reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

const STEPS = [
  { num: "1", title: "Create Your Account", desc: "Sign up securely with two-factor authentication.", img: imgStep1 },
  { num: "2", title: "Add Your Property", desc: "Add your property via address.", img: imgStep2 },
  { num: "3", title: "Select Your Parking Spaces", desc: "Choose the parking spaces you'd like to make available to autonomous fleets.", img: imgStep3 },
  { num: "5", title: "Set Your Availability", desc: "Define the days and hours your spaces are available.", img: imgStep4 },
  { num: "4", title: "Earn Revenue", desc: "Earn recurring revenue when fleets utilize your designated parking spaces via GeoParking Platform.", img: imgStep5 },
];

function StepCard({ num, title, desc, img }) {
  return (
    <div className="flex gap-[16px] items-start">
      <div className="relative left-0 top-[-8px] drop-shadow-[0px_1px_1px_rgba(0,0,0,0.25)] flex items-center justify-center rounded-full size-[30px]"
          style={{ background: "radial-gradient(circle at 50% 50%, #ffffff 0%, #f4f4f4 100%)", border: "1px solid #388e3c" }}>
          <span className="font-['Lato:Bold',sans-serif] text-[#388e3c] text-[14px] leading-none">{num}</span>
      </div>
      <div className="flex-shrink-0 w-auto h-[157px] sm:h-[200px]">
        <img alt="" className="w-auto h-[157px] object-contain" src={img} />
      </div>
      <div className="relative flex-1 pt-[20px]">
        <p className="font-['Montserrat:SemiBold',sans-serif] font-semibold text-[#050000] text-[clamp(0.9rem,1.1vw,1.1rem)] leading-[1.3] mb-[6px]">{title}</p>
        <p className="font-['Lato:Regular',sans-serif] text-[#333] text-[clamp(0.8rem,0.95vw,0.95rem)] leading-[1.4]">{desc}</p>
      </div>
    </div>
  );
}

function HArrow() {
  return (
    <div className="hidden xl:flex flex-shrink-0 items-center justify-center w-[100px]">
     <svg width="103" height="23" viewBox="0 0 103 23" fill="none" style={{ marginTop: '60%' }}>
      <path d="M102.061 12.1075C102.646 11.5217 102.646 10.572 102.061 9.98621L92.5147 0.440273C91.9289 -0.145514 90.9792 -0.145514 90.3934 0.440273C89.8076 1.02606 89.8076 1.97581 90.3934 2.56159L98.8787 11.0469L90.3934 19.5322C89.8076 20.1179 89.8076 21.0677 90.3934 21.6535C90.9792 22.2393 91.9289 22.2393 92.5147 21.6535L102.061 12.1075ZM0 11.0469V12.5469H1.48529V11.0469V9.54688H0V11.0469ZM4.45588 11.0469V12.5469H7.42647V11.0469V9.54688H4.45588V11.0469ZM10.3971 11.0469V12.5469H13.3676V11.0469V9.54688H10.3971V11.0469ZM16.3382 11.0469V12.5469H19.3088V11.0469V9.54688H16.3382V11.0469ZM22.2794 11.0469V12.5469H25.25V11.0469V9.54688H22.2794V11.0469ZM28.2206 11.0469V12.5469H31.1912V11.0469V9.54688H28.2206V11.0469ZM34.1618 11.0469V12.5469H37.1324V11.0469V9.54688H34.1618V11.0469ZM40.1029 11.0469V12.5469H43.0735V11.0469V9.54688H40.1029V11.0469ZM46.0441 11.0469V12.5469H49.0147V11.0469V9.54688H46.0441V11.0469ZM51.9853 11.0469V12.5469H54.9559V11.0469V9.54688H51.9853V11.0469ZM57.9265 11.0469V12.5469H60.8971V11.0469V9.54688H57.9265V11.0469ZM63.8677 11.0469V12.5469H66.8382V11.0469V9.54688H63.8677V11.0469ZM69.8088 11.0469V12.5469H72.7794V11.0469V9.54688H69.8088V11.0469ZM75.75 11.0469V12.5469H78.7206V11.0469V9.54688H75.75V11.0469ZM81.6912 11.0469V12.5469H84.6618V11.0469V9.54688H81.6912V11.0469ZM87.6324 11.0469V12.5469H90.603V11.0469V9.54688H87.6324V11.0469ZM93.5735 11.0469V12.5469H96.5441V11.0469V9.54688H93.5735V11.0469ZM99.5147 11.0469V12.5469H101V11.0469V9.54688H99.5147V11.0469Z" fill="#898989"/>
     </svg>
    </div>
  );
}

function HrevArrow() {
  return (
    <div className="hidden xl:flex flex-shrink-0 items-center justify-center w-[100px]">
    <svg width="103" height="23" viewBox="0 0 103 23" fill="none" style={{ marginTop: '60%' }}>
      <path d="M0.439339 12.1075C-0.146446 11.5217 -0.146446 10.572 0.439339 9.98621L9.98528 0.440273C10.5711 -0.145514 11.5208 -0.145514 12.1066 0.440273C12.6924 1.02606 12.6924 1.97581 12.1066 2.56159L3.62132 11.0469L12.1066 19.5322C12.6924 20.1179 12.6924 21.0677 12.1066 21.6535C11.5208 22.2393 10.5711 22.2393 9.98528 21.6535L0.439339 12.1075ZM102.5 11.0469V12.5469H101.015V11.0469V9.54688H102.5V11.0469ZM98.0441 11.0469V12.5469H95.0735V11.0469V9.54688H98.0441V11.0469ZM92.1029 11.0469V12.5469H89.1324V11.0469V9.54688H92.1029V11.0469ZM86.1618 11.0469V12.5469H83.1912V11.0469V9.54688H86.1618V11.0469ZM80.2206 11.0469V12.5469H77.25V11.0469V9.54688H80.2206V11.0469ZM74.2794 11.0469V12.5469H71.3088V11.0469V9.54688H74.2794V11.0469ZM68.3382 11.0469V12.5469H65.3676V11.0469V9.54688H68.3382V11.0469ZM62.3971 11.0469V12.5469H59.4265V11.0469V9.54688H62.3971V11.0469ZM56.4559 11.0469V12.5469H53.4853V11.0469V9.54688H56.4559V11.0469ZM50.5147 11.0469V12.5469H47.5441V11.0469V9.54688H50.5147V11.0469ZM44.5735 11.0469V12.5469H41.6029V11.0469V9.54688H44.5735V11.0469ZM38.6323 11.0469V12.5469H35.6618V11.0469V9.54688H38.6323V11.0469ZM32.6912 11.0469V12.5469H29.7206V11.0469V9.54688H32.6912V11.0469ZM26.75 11.0469V12.5469H23.7794V11.0469V9.54688H26.75V11.0469ZM20.8088 11.0469V12.5469H17.8382V11.0469V9.54688H20.8088V11.0469ZM14.8676 11.0469V12.5469H11.897V11.0469V9.54688H14.8676V11.0469ZM8.92646 11.0469V12.5469H5.95587V11.0469V9.54688H8.92646V11.0469ZM2.98528 11.0469V12.5469H1.5V11.0469V9.54688H2.98528V11.0469Z" fill="#898989"/>
    </svg>
    </div>
  );
}

function VArrow() {
  return (
    <div className="hidden xl:flex items-center justify-end pr-[calc(350px/2-11px)] w-full h-[100px]">
      <svg width="23" height="103" viewBox="0 0 23 103" fill="none">
        <path d="M9.98621 102.061C10.572 102.646 11.5217 102.646 12.1075 102.061L21.6535 92.5147C22.2393 91.9289 22.2393 90.9792 21.6535 90.3934C21.0677 89.8076 20.1179 89.8076 19.5322 90.3934L11.0469 98.8787L2.56159 90.3934C1.97581 89.8076 1.02606 89.8076 0.440273 90.3934C-0.145514 90.9792 -0.145514 91.9289 0.440273 92.5147L9.98621 102.061ZM11.0469 0H9.54688V1.48529H11.0469H12.5469V0H11.0469ZM11.0469 4.45588H9.54688V7.42647H11.0469H12.5469V4.45588H11.0469ZM11.0469 10.3971H9.54688V13.3676H11.0469H12.5469V10.3971H11.0469ZM11.0469 16.3382H9.54688V19.3088H11.0469H12.5469V16.3382H11.0469ZM11.0469 22.2794H9.54688V25.25H11.0469H12.5469V22.2794H11.0469ZM11.0469 28.2206H9.54688V31.1912H11.0469H12.5469V28.2206H11.0469ZM11.0469 34.1618H9.54688V37.1324H11.0469H12.5469V34.1618H11.0469ZM11.0469 40.1029H9.54688V43.0735H11.0469H12.5469V40.1029H11.0469ZM11.0469 46.0441H9.54688V49.0147H11.0469H12.5469V46.0441H11.0469ZM11.0469 51.9853H9.54688V54.9559H11.0469H12.5469V51.9853H11.0469ZM11.0469 57.9265H9.54688V60.8971H11.0469H12.5469V57.9265H11.0469ZM11.0469 63.8677H9.54688V66.8382H11.0469H12.5469V63.8677H11.0469ZM11.0469 69.8088H9.54688V72.7794H11.0469H12.5469V69.8088H11.0469ZM11.0469 75.75H9.54688V78.7206H11.0469H12.5469V75.75H11.0469ZM11.0469 81.6912H9.54688V84.6618H11.0469H12.5469V81.6912H11.0469ZM11.0469 87.6324H9.54688V90.603H11.0469H12.5469V87.6324H11.0469ZM11.0469 93.5735H9.54688V96.5441H11.0469H12.5469V93.5735H11.0469ZM11.0469 99.5147H9.54688V101H11.0469H12.5469V99.5147H11.0469Z" fill="#898989"/>
      </svg>
    </div>
  );
}

function HowItWorks() {
  const row1 = STEPS.slice(0, 3);
  const row2 = STEPS.slice(3);
  return (
    <div className="gap-[16px]">
      <p className="font-['Montserrat:Bold',sans-serif] font-bold text-[#050000] text-[clamp(1.3rem,2vw,2rem)] text-center leading-[1.3] mb-[clamp(24px,4vw,48px)]">
        How It Works
      </p>
      <div className="flex flex-col xl:flex-row items-start gap-[16px] xl:gap-[16px]">
        {row1.map((step, i) => (
          <Fragment key={step.num}>
            <div className="flex-1 min-w-auto"><StepCard {...step} /></div>
            {i < row1.length - 1 && <HArrow />}
          </Fragment>
        ))}
      </div>
      <VArrow />
      <div className="flex flex-col xl:flex-row-reverse items-start gap-[16px] xl:gap-[16px]">
        {[...row2].reverse().map((step, i, arr) => (
          <Fragment key={step.num}>
            <div className="flex-1 min-w-auto"><StepCard {...step} /></div>
            {i < arr.length - 1 && <HrevArrow />}
          </Fragment>
        ))}
        <div className="flex-shrink min-w-[150px]"></div>
      </div>
    </div>
  );
}

function UnlockRow() {
  return (
    <div className="flex flex-col sm:flex-row items-center gap-[clamp(16px,4vw,60px)] py-[20px]">
      <div className="flex flex-col gap-[12px] flex-shrink">
        <p className="font-['Montserrat:Bold',sans-serif] font-bold text-[#050000] text-[clamp(1.2rem,2vw,2rem)] leading-[1.3]">
          Unlock the Value of Your Parking Assets
        </p>
        <p className="font-['Lato:Regular',sans-serif] text-[#333] text-[clamp(0.95rem,1.2vw,1.25rem)] leading-[1.3]">
          Turn idle areas into sustainable, revenue-generating hubs for autonomous mobility
        </p>
      </div>
      <div className="flex-shrink-0">
        <svg fill="none" height="88" viewBox="0 0 165 132" width="110">
          <g clipPath="url(#clip_tech_layer)">
            <path d={svgPaths.p18cbc200} fill="#3F8ED7" />
            <path d={svgPaths.pa919880} fill="#A3CBE3" />
            <path d={svgPaths.pa9e6f00} fill="#A3CBE3" />
            <path d={svgPaths.pea11100} fill="#2B2B2B" />
            <path d={svgPaths.p24b1bbf0} fill="#2B2B2B" />
            <path d={svgPaths.p47ccb00} fill="#3F8ED7" />
            <path d={svgPaths.p94ae500} fill="white" />
            <path d={svgPaths.p1dfbd900} fill="#E0E0E0" />
            <path d={svgPaths.p2693b80} fill="#E0E0E0" />
          </g>
          <defs>
            <clipPath id="clip_tech_layer"><rect fill="white" height="132" width="165" /></clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
}

function FleetCard({ icon, title, desc }) {
  return (
    <div className="flex flex-col gap-[16px] items-start">
      {icon}
      <div className="flex flex-col gap-[10px]">
        <p className="font-['Lato:SemiBold',sans-serif] text-white text-[clamp(1rem,1.2vw,1.25rem)] leading-[1.3]">{title}</p>
        <p className="font-['Lato:Regular',sans-serif] text-[#898989] text-[clamp(0.9rem,1vw,1.1rem)] leading-[1.3]">{desc}</p>
      </div>
    </div>
  );
}

const FLEET_CARDS = [
  { icon: <svg fill="none" height="40" viewBox="0 0 40 40" width="40"><path d={svgPaths.p2b3de5c0} stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" /><path d={svgPaths.p28ddb80} stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" /><path d="M28.3333 26.6667V26.6833" stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" /><path d="M10 26.6667V26.6833" stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" /><path d={svgPaths.p2a97d600} stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" /><path d={svgPaths.p31868f00} stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" /></svg>, title: "Increase Fleet Utilization", desc: "Keep vehicles closer to passengers with real-time parking intelligence that maximizes uptime and reduces idle driving." },
  { icon: <svg fill="none" height="40" viewBox="0 0 40 40" width="40"><path d={svgPaths.p1c47e600} fill="#0A66C2" stroke="#0A66C2" /></svg>, title: "Reduce Operating Costs", desc: "Lower deadhead miles and minimize unnecessary repositioning with distributed staging locations across the city." },
  { icon: <svg fill="none" height="40" viewBox="0 0 40 40" width="40"><path d={svgPaths.p108f2980} stroke="#0A66C2" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" /></svg>, title: "Scale Without Building Infrastructure", desc: "Expand into new markets using existing parking assets instead of investing in dedicated depots and long-term leases." },
  { icon: <svg fill="none" height="40" viewBox="0 0 40 40" width="40"><path d={svgPaths.p3911f600} stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" /><path d={svgPaths.p3d52ce40} stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" /><path d={svgPaths.p2dc76e80} stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" /><path d={svgPaths.p259baa00} stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" /><path d={svgPaths.pd35b100} stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" /></svg>, title: "One API. Thousands of Parking Locations", desc: "Programmatically find, reserve, and pay for parking through a single integration while GeoParking handles the complexity of parking inventory." },
];

function GreenBanner() {
  return (
    <div className="flex gap-[24px] items-start px-[32px] py-[16px] rounded-[10px]"
      style={{ background: "linear-gradient(90deg, rgba(56,142,60,1) 0%, rgba(56,142,60,1) 100%)" }}>
      <div className="flex-shrink-0 mt-[2px]">
        <svg fill="none" height="32" viewBox="0 0 34.5 32" width="32">
          <path d={svgPaths.p1f04bf80} stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
        </svg>
      </div>
      <p className="font-['Lato:Regular',sans-serif] text-white text-[clamp(0.95rem,1.1vw,1.25rem)] leading-[1.3]">
        As autonomous fleets grow, they need thousands of distributed parking locations, not just centralized depots. GeoParking helps property owners meet that demand while creating new revenue opportunities.
      </p>
    </div>
  );
}

function ShapeTheFuture() {
  return (
    <div className="flex flex-col lg:flex-row gap-[32px] items-stretch">
      <div className="flex-1 rounded-[10px] overflow-hidden relative min-h-[525px] border-[1px] border-[#5C5C5C]">
        <img alt="" className="absolute inset-0 w-full h-full object-cover" src={imgShape} />
        <div className="absolute inset-0 bg-[rgba(0,0,0,0.55)]" />
        <div className="relative z-10 p-[24px] flex flex-col gap-[20px] h-full justify-end">
          <div className="flex gap-[16px] items-center">
            <div className="flex items-center justify-center rounded-[8px] size-[48px]" style={{ background: "rgba(67,214,81,0.2)", border: "1px solid #43D651" }}>
              <svg fill="none" height="36" viewBox="0 0 48 48" width="36"><path d={svgPaths.p2d2e0700} stroke="#43D651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" /></svg>
            </div>
            <div className="flex flex-col gap-[4px]">
              <p className="font-['Google_Sans_Flex:Medium',sans-serif] font-medium text-white text-[clamp(1.1rem,1.4vw,1.4rem)] leading-normal" style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}>Shape the Future of Mobility</p>
              <div className="bg-[#76e688] h-[3px] w-[41px]" />
            </div>
          </div>
          <ul className="font-['Lato:Regular',sans-serif] text-white text-[clamp(0.9rem,1vw,1rem)] leading-[1.3] list-disc space-y-[9px]">
            <li className="mb-1">Join the growing network supporting the next generation of autonomous transportation.</li>
            <li className="mb-1">Help accelerate the adoption of electric robotaxi fleets while reducing unnecessary traffic by eliminating empty trips back to distant depots.</li>
            <li className="mb-1">Contribute to cleaner, smarter cities while putting existing parking infrastructure to better use.</li>
          </ul>
        </div>
      </div>
      <div className="flex-1 rounded-[10px] overflow-hidden relative min-h-[525px] border-[1px] border-[#5C5C5C]">
        <img alt="" className="absolute inset-0 w-full h-full object-cover" src={imgUnlock} />
        <div className="absolute inset-0 bg-[rgba(0,0,0,0.55)]" />
        <div className="relative z-10 p-[24px] flex flex-col gap-[20px] h-full justify-end">
          <div className="flex gap-[16px] items-center">
            <div className="flex items-center justify-center rounded-[8px] size-[48px]" style={{ background: "rgba(1,79,164,0.2)", border: "1px solid #0A66C2" }}>
              <svg width="30" height="28" viewBox="0 0 25 22" fill="none"><path d="M16.7705 9.07129C17.5756 9.07154 18.2207 9.73458 18.2207 10.543V20.2471C18.2207 21.0556 17.5756 21.7185 16.7705 21.7188H14.8486C14.0435 21.7186 13.3985 21.0557 13.3984 20.2471V10.543C13.3984 9.73452 14.0435 9.07144 14.8486 9.07129H16.7705ZM23.2988 7.84961C24.1041 7.84961 24.75 8.51257 24.75 9.32129V20.2471C24.75 21.0558 24.1041 21.7188 23.2988 21.7188H21.3779C20.5727 21.7186 19.9277 21.0557 19.9277 20.2471V9.32129C19.9277 8.51264 20.5727 7.84972 21.3779 7.84961H23.2988ZM3.71191 11.8926C4.51697 11.8927 5.16195 12.5558 5.16211 13.3643V20.2324C5.16201 21.041 4.51701 21.7039 3.71191 21.7041H1.79004C0.984998 21.7039 0.33994 21.0409 0.339844 20.2324V13.3643C0.340002 12.5558 0.985037 11.8928 1.79004 11.8926H3.71191ZM10.2412 10.4746C11.0463 10.4748 11.6913 11.1377 11.6914 11.9463V20.2324C11.6913 21.0409 11.0463 21.7039 10.2412 21.7041H8.31934C7.51426 21.7039 6.86924 21.0409 6.86914 20.2324V11.9463C6.8692 11.1377 7.51424 10.4748 8.31934 10.4746H10.2412Z" fill="#0A66C2" stroke="#0A66C2" strokeWidth="0.5"/></svg>
            </div>
            <div className="flex flex-col gap-[4px]">
              <p className="font-['Google_Sans_Flex:Medium',sans-serif] font-medium text-white text-[clamp(1.1rem,1.4vw,1.4rem)] leading-normal" style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}>Unlock Effortless Revenue</p>
              <div className="bg-[#76e688] h-[3px] w-[41px]" />
            </div>
          </div>
          <ul className="font-['Lato:Regular',sans-serif] text-white text-[clamp(0.9rem,1vw,1rem)] leading-[1.3] list-disc space-y-[9px]">
            <li className="mb-1">Monetize parking spaces that would otherwise sit empty in your off peak hours.</li>
            <li className="mb-1">View and transfer your earnings directly from your Property Owner Dashboard.</li>
            <li className="mb-1">No hardware installation required for parking.</li>
            <li className="mb-1">10-minute Onboarding.</li>
          </ul>
        </div>
      </div>
      <div className="flex-1 rounded-[10px] overflow-hidden relative min-h-[525px] border-[1px] border-[#5C5C5C]">
        <img alt="" className="absolute inset-0 w-full h-full object-cover" src={imgStay} />
        <div className="absolute inset-0 bg-[rgba(0,0,0,0.55)]" />
        <div className="relative z-10 p-[24px] flex flex-col gap-[20px] h-full justify-end">
          <div className="flex gap-[16px] items-center">
            <div className="flex items-center justify-center rounded-[8px] size-[48px]" style={{ background: "rgba(151,71,255,0.2)", border: "1px solid #B075FE" }}>
              <svg width="30" height="28" viewBox="0 0 24 22" fill="none"><path d="M22.4039 17.6681C23.4381 15.9002 24 13.896 24 11.802C24 7.46853 21.6067 3.68377 18.058 1.63113C18.037 1.61523 18.0224 1.59296 17.999 1.58023C17.9812 1.5691 17.9586 1.56989 17.94 1.56115C16.187 0.573401 14.1616 0 12.0004 0C9.83917 0 7.81457 0.573401 6.06246 1.55956C6.04225 1.56989 6.02041 1.56989 6.00101 1.58103C5.97675 1.59455 5.9622 1.61841 5.94037 1.63352C4.17532 2.65387 2.70215 4.10209 1.66317 5.8374C1.647 5.86046 1.62356 5.87398 1.609 5.89864C1.59768 5.91852 1.59768 5.94079 1.58879 5.95987C0.586194 7.68167 0.00404272 9.66829 0.00242563 11.7901C0.00242563 11.7933 0 11.7965 0 11.8013C0 11.8052 0.00161709 11.8084 0.00242563 11.8132C0.00404272 13.9008 0.562746 15.8994 1.59202 17.6617Z" fill="#B075FE"/></svg>
            </div>
            <div className="flex flex-col gap-[4px]">
              <p className="font-['Google_Sans_Flex:Medium',sans-serif] font-medium text-white text-[clamp(1.1rem,1.4vw,1.4rem)] leading-normal" style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}>Stay in Control</p>
              <div className="bg-[#76e688] h-[3px] w-[41px]" />
            </div>
          </div>
          <ul className="font-['Lato:Regular',sans-serif] text-white text-[clamp(0.9rem,1vw,1rem)] leading-[1.3] list-disc space-y-[9px]">
            <li className="mb-1">Choose exactly which spaces participate.</li>
            <li className="mb-1">Set available hours around your business operations.</li>
            <li className="mb-1">Update availability anytime through your dashboard.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function FleetSection() {
  return (
    <section className="bg-[#121212] py-[clamp(40px,6vw,80px)]">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col gap-[clamp(32px,4vw,60px)]">
          <div className="tech-reveal flex flex-col gap-[12px]">
            <p className="font-['Google_Sans_Flex:Medium',sans-serif] font-medium text-white text-[clamp(1.5rem,2.5vw,2.5rem)] leading-[1.3] py-[clamp(3vw,4vw,0vw)]" style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}>
              Robotaxis
            </p>
            <p className="font-['Montserrat:Bold',sans-serif] font-bold text-white text-[clamp(1.4rem,2.5vw,2rem)] leading-[1.3] max-w-[1400px]">
              Maximize Your Robotaxi Fleet Efficiency
            </p>
            <p className="font-['Lato:Regular',sans-serif] text-[#6b6b6b] text-[clamp(1rem,1.2vw,1.25rem)] leading-[1.4] max-w-[1400px]">
              A connected, data-driven parking ecosystem built to keep autonomous fleets moving—faster, cleaner, and with greater operational reliability.
            </p>
          </div>
          <div className="flex w-full">
            <div className="flex-shrink w-[35%] px-[clamp(16px,4vw,60px)]">
              <img alt="" className="w-[450px] h-auto" src={imgMaximize} />
            </div>
            <div className="tech-reveal w-[65%] px-[clamp(16px,4vw,60px)] grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-2 gap-[clamp(24px,3vw,60px)]">
              {FLEET_CARDS.map((card) => (
                <FleetCard key={card.title} {...card} />
              ))}
            </div>
          </div>
          <div className="tech-reveal"><GreenBanner /></div>
          <div className="tech-reveal"><ShapeTheFuture /></div>
        </div>
      </div>
    </section>
  );
}

function PropertyOwnersSection() {
  return (
    <section className="bg-white py-[clamp(40px,6vw,80px)]">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col gap-[clamp(32px,4vw,60px)]">
          <div className="tech-reveal">
            <p className="font-['Google_Sans_Flex:Medium',sans-serif] font-medium text-black text-[clamp(1.6rem,2.8vw,2.5rem)] leading-[1.3]" style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}>
              Property Owners
            </p>
          </div>
          <div className="tech-reveal"><HowItWorks /></div>
          <div className="tech-reveal bg-[#ebebeb] rounded-[8px] w-[80%] center m-auto p-[clamp(42px,3vw,42px)] flex">
            <div className="w-[50%] justify-center gap-[16px] flex">
              <p className="font-['Montserrat:SemiBold',sans-serif] font-semibold text-[#050000] text-[clamp(1rem,1.4vw,1.5rem)] leading-[1.3]">
                Manage your parking availability, track earnings, and view your property's performance through the GeoParking platform.
              </p>
            </div>
            <div className="w-[50%] justify-center items-center gap-[16px]">
              <img alt="" className="w-full h-auto object-cover" src={imgFleetCard} />
            </div>
          </div>
          <div className="tech-reveal"><UnlockRow /></div>
        </div>
      </div>
    </section>
  );
}

export default function TechnologyPage() {
  useReveal();
  return (
    <div className="bg-[#f5f5f5] min-h-screen">
      <Header />
      <main>
        {/* Hero */}
        <div className="pt-20">
          <div className="relative w-full overflow-hidden" style={{ height: "140px" }}>
            <div className="absolute inset-0 hero-bg-animate" style={{ transformOrigin: "center top" }}>
              <img alt="" className="absolute inset-0 max-w-none pointer-events-none size-full object-cover" src={imgHeroBg} />
            </div>
            <div className="absolute inset-0 bg-[rgba(255,255,255,0.8)]" />
            <div className="relative z-10 max-w-[1400px] mx-auto px-6 h-full flex items-center">
              <p className="hero-title-animate font-['Montserrat:Bold',sans-serif] font-bold text-black text-[clamp(1.4rem,3.2vw,2.75rem)] leading-[1.3]">
                Innovation That Powers Every Space
              </p>
            </div>
          </div>
        </div>
        <PropertyOwnersSection />
        <FleetSection />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
